module.exports = __webpack_public_path__ + "img/collection-diamondJewelryBestseller.1c198b2.jpg";